<template>
  <div>
    <!-- Modale -->
    <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog"
      aria-labelledby="userDataIpaModalTitle">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <!-- Header -->
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h5 class="modal-title mb-0" id="userDataIpaModalTitle">Selezione ente di appartenenza</h5>
            <div class="d-flex align-items-center gap-2">
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="$emit('switch')">
                Non trovo il mio Ente
              </button>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label fw-semibold">Nome</label>
                <input type="text" class="form-control" :value="user.nome" />
              </div>
              <div class="col-md-4">
                <label class="form-label fw-semibold">Cognome</label>
                <input type="text" class="form-control" :value="user.cognome" />
              </div>
              <div class="col-md-4">
                <label class="form-label fw-semibold">Codice Fiscale</label>
                <input type="text" class="form-control" :value="user.fiscal_code" />
              </div>

              <div class="col-12 mt-3">
                <label for="ipaSearch" class="form-label fw-semibold">Cerca Ente (IPA)</label>
                <input id="ipaSearch" type="text" class="form-control" v-model="searchText" @input="onSearchInput"
                  placeholder="Digita almeno 3 lettere per cercare..." />
              </div>

              <div v-if="loadingIpa" class="text-center mt-3">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Caricamento enti...</span>
                </div>
                <div class="text-secondary mt-2">Caricamento enti...</div>
              </div>

              <div class="col-12 mt-3" v-if="ipaList.length > 0">
                <label for="ipaSelect" class="form-label fw-semibold">Seleziona Ente</label>
                <select id="ipaSelect" v-model="selectedIpa" class="form-select" @change="onEnteSelected" required>
                  <option value="" disabled>-- Seleziona un ente --</option>
                  <option v-for="ente in ipaList" :key="ente.cod_amm" :value="ente.cod_amm">
                    {{ truncate(ente.des_amm, 80) }}
                  </option>
                </select>
              </div>

              <div v-if="loadingUo" class="text-center mt-3">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Caricamento UO...</span>
                </div>
                <div class="text-secondary mt-2">Caricamento UO...</div>
              </div>

              <div class="col-12 mt-3" v-if="uoList.length > 0">
                <label for="uoSelect" class="form-label fw-semibold">Seleziona Unità Organizzativa</label>
                <select id="uoSelect" v-model="selectedUo" class="form-select" @change="loadDomicilioDigitale">
                  <option value="" disabled>-- Seleziona UO --</option>
                  <option v-for="uo in uoList" :key="uo.cod_uni_ou" :value="uo.cod_uni_ou">
                    {{ truncate(uo.des_ou, 80) }}
                  </option>
                </select>
              </div>

              <div v-if="loadingDomicilio" class="text-center mt-3">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Caricamento domicilio digitale...</span>
                </div>
                <div class="text-secondary mt-2">Caricamento domicilio digitale...</div>
              </div>

              <div class="col-12 mt-3" v-if="!loadingDomicilio && selectedUo">
                <label class="form-label fw-semibold">Domicilio Digitale</label>

                <div v-if="selectedUo">
                  <div v-if="domicilioDigitale">
                    <input type="text" class="form-control" :value="domicilioDigitale" readonly />
                  </div>

                  <div v-else class="alert alert-warning mt-2">
                    Non è presente alcun domicilio digitale associato a questa UO.
                  </div>
                </div>
              </div>




              <div v-if="loading" class="text-center mt-3 text-secondary">Caricamento...</div>
              <div v-if="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer d-flex flex-column">
            <button type="button" class="btn btn-primary w-100 mb-2" :disabled="!domicilioDigitale || loadingOtp"
              @click="richiediOtp">
              <span v-if="loadingOtp" class="spinner-border spinner-border-sm me-2" role="status"></span>
              <span>{{ otpRequested ? 'Invia di nuovo OTP' : 'Richiedi OTP' }}</span>
            </button>


            <div v-if="otpSuccessMessage" class="alert alert-success w-100 mt-2 mb-0 text-center">
              {{ otpSuccessMessage }}
            </div>

            <!--<a class="btn btn-danger w-100" role="button"
              :href="this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/logout'">
              <svg class="icon icon-sm icon-white me-2">
                <use :href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-logout'"></use>
              </svg>
              Chiudi
            </a>-->
            <button class="btn btn-danger w-100" @click="closeModal">
            Chiudi
          </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Overlay scuro -->
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>

  <!-- Modale OTP -->
  <div v-if="showOtpModal" class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Verifica codice OTP</h5>
          <button type="button" class="btn-close" @click="closeOtpModal"></button>
        </div>
        <div class="modal-body text-center">
          <p>Inserisci il codice OTP ricevuto al tuo domicilio digitale.</p>
          <input type="text" v-model="otpCode" maxlength="6"
            class="form-control text-center fw-bold fs-4 tracking-widest" placeholder="------" />
          <div v-if="otpErrorMessage" class="alert alert-danger mt-3">{{ otpErrorMessage }}</div>
        </div>
        <div class="modal-footer d-flex flex-column">
          <button class="btn btn-success w-100 mb-2" @click="verificaOtp" :disabled="!otpCode || loadingVerify">
            <span v-if="loadingVerify" class="spinner-border spinner-border-sm me-2"></span>
            Verifica OTP
          </button>
          <button class="btn btn-outline-primary w-100 mb-2" @click="richiediOtp" :disabled="loadingOtp">
            <span v-if="loadingOtp" class="spinner-border spinner-border-sm me-2"></span>
            Invia nuovo PIN
          </button>
          <button class="btn btn-outline-secondary w-100" @click="closeOtpModal">
            Chiudi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDataIpaModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      user: this.$root.user || {},
      ipaList: [],
      selectedIpa: '',
      uoList: [],
      selectedUo: '',
      domicilioDigitale: '',
      loading: false,
      errorMessage: '',
      otpErrorMessage: '',
      searchText: '',
      searchTimeout: null,
      loadingIpa: false,
      loadingUo: false,
      loadingDomicilio: false,
      otpRequested: false,
      otpCode: '',
      loadingOtp: false,
      loadingVerify: false,
      otpSuccessMessage: '',
      showOtpModal: false,
    };
  },
  watch: {
    show(val) {
      if (!val) {
        this.searchText = '';
        this.ipaList = [];
        this.errorMessage = '';
      }
    }
  },
  computed: {
    selectedUoObject() {
      return this.uoList.find(uo => uo.cod_uni_ou === this.selectedUo) || null;
    }
  },
  methods: {
    async logoutUtente() {
      try {
        localStorage.removeItem('showed_user_request_ipa')
        //localStorage.removeItem('token');
        // Esegui logout via redirect (SSO)
        window.location.href = this.$root.config.VITE_APP_BACKOFFICE_URL + '/auth/sso/logout';
      } catch (err) {
        console.error('Errore durante il logout:', err);
      }
    },
    closeOtpModal() {
      this.showOtpModal = false;
      this.otpCode = '';
      this.otpErrorMessage = '';
    },
    async richiediOtp() {
      if (!this.domicilioDigitale) return;
      this.loadingOtp = true;
      this.errorMessage = '';

      try {
        const response = await this.$root.$api.post('/otp/send', {
          email: this.domicilioDigitale,
          user_id: this.user.sub,
        });

        if (response.data.success) {
          this.otpRequested = true;
          this.showOtpModal = true;
        } else {
          this.errorMessage = response.data.message || 'Errore durante l’invio dell’OTP.';
        }
      } catch (err) {
        console.error('Errore invio OTP:', err);
        this.errorMessage = 'Errore durante l’invio dell’OTP. Riprova più tardi.';
      } finally {
        this.loadingOtp = false;
      }
    },

    async verificaOtp() {
      if (!this.otpCode || !this.selectedUoObject) return;
      this.loadingVerify = true;
      this.errorMessage = '';

      try {
        const response = await this.$root.$api.post('/otp/verify', {
          user_id: this.user.sub,
          otp_code: this.otpCode,
          cod_amm: this.selectedUoObject.cod_amm,
          cod_uni_ou: this.selectedUoObject.cod_uni_ou,
          comune: this.selectedUoObject.comune,
          regione: this.selectedUoObject.regione,
          des_ou: this.selectedUoObject.des_ou,
        });

        if (response.data.success) {
          const token = response.data.token;
          localStorage.setItem('token', token);
          //this.$root.$api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          document.cookie = `digitapp_session=${token}; path=/;`; 
          this.$root.user = { ...this.$root.user, active: true };
          this.closeModal();
          this.$root.currentView.value = this.$root.views.QuestionsView;
          this.$router.push('/questions');
          //localStorage.removeItem('showed_user_request_ipa')
        } else {
          this.otpErrorMessage = 'OTP non valido o scaduto.';
        }
      } catch (err) {
        console.error('Errore verifica OTP:', err);
        this.otpErrorMessage = 'Errore durante la verifica OTP.';
      } finally {
        this.loadingVerify = false;
      }
    },

    truncate(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '…' : text;
    },

    async onEnteSelected() {
      if (!this.selectedIpa) return;
      this.uoList = [];
      this.selectedUo = '';
      this.domicilioDigitale = '';
      this.loadingUo = true;

      try {
        const response = await this.$root.$api.get('/ipa/uo', {
          params: { cod_amm: this.selectedIpa }
        });
        this.uoList = Array.isArray(response.data.data) ? response.data.data : [];
      } catch (err) {
        console.error('Errore caricamento UO:', err);
        this.errorMessage = 'Errore durante il caricamento delle unità organizzative.';
      }
      finally {
        this.loadingUo = false;
      }
    },

    async loadDomicilioDigitale() {
      if (!this.selectedUo) return;
      this.loadingDomicilio = true;

      try {
        const response = await this.$root.$api.get('/ipa/domicilio', {
          params: { cod_uni_ou: this.selectedUo }
        });
        this.domicilioDigitale = response.data.domicilio_digitale || '';
      } catch (err) {
        console.error('Errore caricamento domicilio digitale:', err);
        this.errorMessage = 'Errore durante il recupero del domicilio digitale.';
      }
      finally {
        this.loadingDomicilio = false;
      }
    },
    closeModal(fromCloseButton = false) {
      this.$emit('update:show', false);
      if (fromCloseButton) {
        this.logoutUtente();
      }
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      if (this.searchText.length > 3) {
        this.searchTimeout = setTimeout(() => {
          this.loadIpa();
        }, 300);
      } else {
        this.ipaList = [];
      }
    },

    async loadIpa() {
      this.loadingIpa = true;
      this.errorMessage = '';
      try {
        const response = await this.$root.$api.get("/ipa/search", {
          params: { descr: this.searchText }
        });

        const data = await response.data;
        this.ipaList = Array.isArray(data.data) ? data.data : [];
      } catch (err) {
        console.error('Errore ricerca IPA:', err);
        this.errorMessage = 'Errore durante la ricerca IPA. Riprova più tardi.';
      } finally {
        this.loadingIpa = false;
      }
    },

    async saveIpaSelection() {
      if (!this.selectedIpa) {
        this.errorMessage = 'Seleziona un ente prima di continuare.';
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/api/users/${this.user.id}/associate-ipa`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          },
          body: JSON.stringify({ ipa_id: this.selectedIpa })
        });

        if (!response.ok) throw new Error('Errore salvataggio IPA');

        const data = await response.json();

        // Aggiorna utente root e chiudi modale
        this.$root.user = { ...this.$root.user, active: true };
        this.closeModal();

        // Reindirizza alla QuestionsView
        this.$root.currentView.value = this.$root.views.QuestionsView;
        this.$root.currentViewName.value = 'QuestionsView';
        this.$router.push('/questions');
      } catch (err) {
        console.error('Errore salvataggio IPA:', err);
        this.errorMessage = 'Errore durante il salvataggio. Riprova più tardi.';
      }
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  z-index: 1040;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* sfondo scuro trasparente */
}

.modal {
  z-index: 1050;
  display: block;
}

/* Correzione stile input disabilitati come UserSection */
.form-control:disabled,
.form-control[readonly] {
  border-color: #ced4da;
  background-color: #f8f9fa;
}

select.form-select option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}
</style>
